import {useState} from 'react'
import StarboxIcon from '../starboxIcon.svg'
import {useNavigate} from 'react-router-dom'
import block01 from '../img/block-01.png'
import block02 from '../img/block-02.png'
import block03 from '../img/block-03.png'
import block04 from '../img/block-04.png'
import block05 from '../img/block-05.png'
import block05G from '../img/block-05G.png'
import block06 from '../img/block-06.png'
import block07 from '../img/block-07.png'
import block08 from '../img/block-08.png'
import block01E from '../img/block-01E.png'
import block02E from '../img/block-02E.png'
import block03E from '../img/block-03E.png'
import block04E from '../img/block-04E.png'
import block05E from '../img/block-05E.png'
import block05GE from '../img/block-05GE.png'
import block06E from '../img/block-06E.png'
import block07E from '../img/block-07E.png'
import block08E from '../img/block-08E.png'
import strings from '../strings.js'
import SelectingMissingCard from '../SelectingMissingCard';
import SelectingContestCard from '../SelectingContestCard';
import SelectingDanmuCard from '../SelectingDanmuCard';
import SelectingGameCard from '../SelectingGameCard';
import homeLogoBg from '../img2026/homeLogoBg.jpg';
import logoWhite from '../img2026/logoWhite.png';


import menu1 from '../img2026/menu1.avif';
import menu2 from '../img2026/menu2.avif';
import menu3 from '../img2026/menu3.avif';
import menu4 from '../img2026/menu4.avif';
import menu5 from '../img2026/menu5.avif';
import menu6 from '../img2026/menu6.avif';
import menu7 from '../img2026/menu7.avif';
import menu8 from '../img2026/menu8.avif';
import menu9 from '../img2026/menu9.avif';


import ball1 from '../img2026/ball1.avif';
import ball1E from '../img2026/ball1E.avif';
import ball2 from '../img2026/ball2.avif';
import ball2E from '../img2026/ball2E.avif';
import ball3 from '../img2026/ball3.avif';
import ball4 from '../img2026/ball4.avif';
import ball4E from '../img2026/ball4E.avif';
import ball5 from '../img2026/ball5.avif';
import ball5E from '../img2026/ball5E.avif';


export function Home({skin, stateVer, lang, setLang, statePlaylist, stateYouTube, stateDuration}) {
    const navigate = useNavigate()
    const [selectingMissing, setSelectingMissing] = useState(false);
    const [selectingContest, setSelectingContest] = useState(false);
    const [selectingDanmu, setSelectingDanmu] = useState(false);
    const [selectingGame, setSelectingGame] = useState(false);
    function goInMissing() {
      setSelectingMissing(true)
    }
    function goInContest() {
        setSelectingContest(true)
      }
     function goInDanmu() {
        setSelectingDanmu(true)
     }

     const allowedRooms = [
        "602305135291"
    ];

  return (
        <>
                 {skin === 0 && (
                        <div className="topCentreIcon">
                                <img
                                src={StarboxIcon}
                                alt="Starbox"
                                />
                        </div>
                )}

{skin === 1 && (
  <div
    className="topCentreIcon"
    style={{
      padding: '0',
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: '13vh',
      height: '13vh',
      maxHeight: '13vh',
      //minHeight: '48px',
      width: '100%',
      backgroundImage: `url(${homeLogoBg})`,
      backgroundSize: '100% 100%',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
    }}
  >
    <img
      src={logoWhite}
      alt="Starbox"
      style={{
        height: '55%',        // Reduced from 55% to shrink vertical presence
        maxWidth: '60%',      // Constrains horizontal growth
        //maxHeight: '32px',    // Hard ceiling so it stays sleek on large screens
        objectFit: 'contain',
        width: 'auto',
      }}
    />
  </div>
)}

                <div className="mainMenuContainer">
    {skin === 0 ? (
        /* ==================== SKIN 0 (LEAVE UNTOUCHED) ==================== */
        <>
            <a className="block-00" onClick={(e) => {e.preventDefault(); navigate("/home/songs");}}>
                <img style={{width:"100%", height:"100%"}} src={lang ? block01 : block01E} alt="Song" /> 
            </a>
            <a className="block-00" onClick={(e) => {e.preventDefault(); navigate("/home/artists");}}>
                <img style={{width:"100%", height:"100%"}} src={lang ? block02 : block02E} alt="Singer" />
            </a>
            <a className="block-00" onClick={(e) => {e.preventDefault(); navigate("/home/hot");}}>
                <img style={{width:"100%", height:"100%"}} src={lang ? block03 : block03E} alt="Hot Song" />
            </a>
            <a className="block-00" onClick={(e) => {e.preventDefault(); navigate("/home/new");}}>
                <img style={{width:"100%", height:"100%"}} src={lang ? block04 : block04E} alt="New Release" />
            </a>
            <a className="block-00" onClick={(e) => {
                e.preventDefault();
                if (JSON.parse(localStorage.getItem("room")) == "602311130823") {
                    setSelectingGame(true);
                } else {
                    navigate("/home/list");
                }
            }}>
                <img style={{width:"100%", height:"100%"}} src={(JSON.parse(localStorage.getItem("room")) == "602311130823") ? (lang ? block05G : block05GE) : (lang ? block05 : block05E)} alt="Playlist/Game" />
            </a>
            {(stateVer==="dating"||stateVer==="danji") && (
                <a className="block-00" onClick={(e) => {e.preventDefault(); navigate("/home/rec");}}>
                    <img style={{width:"100%", height:"100%"}} src={lang ? block06 : block06E} alt="Record" />
                </a>
            )}
            <a className="block-00" onClick={(e) => {e.preventDefault(); navigate("/home/fav");}}>
                <img style={{width:"100%", height:"100%"}} src={lang ? block07 : block07E} alt="My Song" />
            </a>
            {(stateVer==="wangluo"||stateYouTube===true) && (
                <a className="block-00" onClick={(e) => {e.preventDefault(); navigate("/home/yt");}}>
                    <img style={{width:"100%", height:"100%"}} src={lang ? block08 : block08E} alt="yt" />
                </a>
            )}
        </>
    ) : (
        /* ==================== SKIN 1 (DYNAMIC DENSITY GRID) ==================== */
        <>
            {/* 2x2 Large Top-Left Block */}
            <a className="skin1-tile skin1-large" onClick={(e) => {e.preventDefault(); navigate("/home/songs");}}>
                <img src={menu1} alt="Song" />
                <span className="tile-label">{lang ? "歌曲" : "Songs"}</span>
            </a>

            <a className="skin1-tile" onClick={(e) => {e.preventDefault(); navigate("/home/artists");}}>
                <img src={menu2} alt="Singer" />
                <span className="tile-label">{lang ? "歌星" : "Singers"}</span>
            </a>

            <a className="skin1-tile" onClick={(e) => {e.preventDefault(); navigate("/home/new");}}>
                <img src={menu3} alt="New Release" />
                <span className="tile-label">{lang ? "新歌" : "New Songs"}</span>
            </a>

            <a className="skin1-tile" onClick={(e) => {e.preventDefault(); navigate("/home/hot");}}>
                <img src={menu4} alt="Hot Song" />
                <span className="tile-label">{lang ? "热门" : "Hot Songs"}</span>
            </a>

            <a className="skin1-tile" onClick={(e) => {e.preventDefault(); navigate("/home/fav");}}>
                <img src={menu5} alt="My Song" />
                <span className="tile-label">{lang ? "收藏" : "Favorites"}</span>
            </a>

            {(stateVer==="wangluo"||stateYouTube===true) && (
                <a className="skin1-tile" onClick={(e) => {e.preventDefault(); navigate("/home/yt");}}>
                    <img src={menu6} alt="YouTube" />
                    <span className="tile-label">YouTube</span>
                </a>
            )}

            <a className="skin1-tile" onClick={(e) => {
                e.preventDefault();
                
                    navigate("/home/list");
            }}>
                <img src={ menu7} alt="Playlist/Game" />
                <span className="tile-label">
                    {(lang ? "已点" : "Playlist")}
                </span>
            </a>

            {(stateVer==="dating"||stateVer==="danji") && (
                <a className="skin1-tile" onClick={(e) => {e.preventDefault(); navigate("/home/rec");}}>
                    <img src={menu8} alt="Record" />
                    <span className="tile-label">{lang ? "已录" : "Recorded"}</span>
                </a>
            )}

            <a className="skin1-tile" onClick={(e) => {e.preventDefault(); if (JSON.parse(localStorage.getItem("room")) == "602311130823") {
                    setSelectingGame(true);}}}>
                <img src={menu9} alt="Game" />
                <span className="tile-label">{lang ? "游戏" : "Game"}</span>
            </a>
        </>
    )}
</div>




















                {/* Bottom Section (Text Links for Skin 0 / 5 Round Balls for Skin 1) */}
            <div className="otherLangContainer">
                {skin === 0 ? (
                    /* ==================== SKIN 0 (UNTOUCHED TEXT LINKS) ==================== */
                    <>
                        {!isNaN(stateDuration) ? (
                            <div className="otherLang" onClick={(e) => {e.preventDefault(); goInDanmu();}}>{lang ? strings.cn.danmu : strings.en.danmu}</div>
                        ) : (
                            <div className="otherLang" onClick={(e) => {e.preventDefault();}}></div>
                        )}
                        {allowedRooms.includes(JSON.parse(localStorage.getItem("room"))) ? (
                            <div className="otherLang" onClick={(e) => {e.preventDefault(); goInContest();}}>{lang ? strings.cn.contest : strings.en.contest}</div>
                        ) : (
                            <div className="otherLang" onClick={(e) => {e.preventDefault();}}></div>
                        )}
                        {JSON.parse(localStorage.getItem("room")) === "602305135274" || JSON.parse(localStorage.getItem("room")) === "602305135291" ? (
                            <div className="otherLang" onClick={(e) => {e.preventDefault();}}></div>
                        ) : (
                            <div className="otherLang" onClick={(e) => {e.preventDefault();}}></div>
                        )}
                        <div className="otherLang" onClick={(e) => {e.preventDefault(); setLang(!lang);}}>
                            {lang ? strings.cn.otherLang : strings.en.otherLang}
                        </div>
                    </>
                ) : (
                    /* ==================== SKIN 1 (5 SPHERICAL BUTTONS) ==================== */
                    <div className="skin1-balls-row">
                        {/* Ball 1: Danmu */}
                        <div className="ball-item" onClick={(e) => { e.preventDefault(); if(!isNaN(stateDuration)) goInDanmu(); }}>
                            <img src={lang ? ball1 : ball1E} alt="Danmu" />
                        </div>

                        {/* Ball 2: Contest */}
                        <div className="ball-item" onClick={(e) => { e.preventDefault(); if(allowedRooms.includes(JSON.parse(localStorage.getItem("room")))) goInContest(); }}>
                            <img src={lang ? ball2 : ball2E} alt="Contest" />
                        </div>

                        {/* Ball 3: Static Center Ball */}
                        <div className="ball-item">
                            <img src={ball3} alt="Decoration" />
                        </div>

                        {/* Ball 4: Request / Missing Song */}
                        <div className="ball-item" onClick={(e) => { e.preventDefault(); goInMissing(); }}>
                            <img src={lang ? ball4 : ball4E} alt="Request Song" />
                        </div>

                        {/* Ball 5: Language Switcher */}
                        <div className="ball-item" onClick={(e) => { e.preventDefault(); setLang(!lang); }}>
                            <img src={lang ? ball5 : ball5E} alt="Switch Language" />
                        </div>
                    </div>
                )}
            </div>
                














        { selectingMissing && (
                <>
                <SelectingMissingCard onClick={() => { setSelectingMissing(false);}} stateVer={stateVer} lang={lang}/>
                </>
        )}

        { selectingContest && (
                <>
                <SelectingContestCard onClick={() => { setSelectingContest(false);}} stateVer={stateVer} lang={lang}/>
                </>
        )}

        { selectingDanmu && (
                <>
                <SelectingDanmuCard onClick={() => { setSelectingDanmu(false);}} stateVer={stateVer} lang={lang}/>
                </>
        )}

        { selectingGame && (
                <>
                <SelectingGameCard onClick={() => { setSelectingGame(false);}} stateVer={stateVer} lang={lang}/>
                </>
        )}
        </>
  )
}
//                                        <div className="otherLang" onClick={(e) => {e.preventDefault(); goInMissing();}}>{lang ? strings.cn.missing : strings.en.missing}</div>